import React from "react";
import { observer } from "mobx-react";
import { Tooltip } from "antd";
import Logo from "@app/components/client/logo";
import useIsTruncated from "@app/hooks/useIsTruncated";

import "./style/project.scoped.scss";

import report from "@app/state/store/report";

const Project = observer(() => {
    const [nameRef, isNameTruncated] = useIsTruncated(report.project?.name);

    if (!report.project || report.project.deleted) {
        return;
    }

    return (
        <div className="project">
            <div className="row">
                <div className="logo">
                    <Logo client={report.project.client} size={30} />
                </div>
                <div className="details">
                    {/* <div className="label">Project</div> */}
                    <Tooltip
                        title={isNameTruncated ? report.project.name : ""}
                        placement="bottomLeft"
                    >
                        <div className="name" ref={nameRef}>
                            {report.project.name}
                        </div>
                    </Tooltip>
                    <div className="client">for {report.project.client.name}</div>
                </div>
            </div>
        </div>
    );
});

export default Project;
